module.exports = __webpack_public_path__ + "img/116025.78c001ea.png";